<template>
  <div>
     <div class="popover_header">
      
        <h2>Select A Cabinet Color</h2>
        <div class="popover_stroke"></div>
      </div>
      <div class="popover_body">
        
        <a v-for="setting in settings" v-bind:class="selected === setting.title.toLowerCase() ? 'active' : '' " @click.prevent="setCabinet(setting.title.toLowerCase())" href="#">
          <img v-bind:src="setting.thumb" alt=""><span>{{setting.title}}</span>
        </a>
        
      <!--  <a v-bind:class="chestnut ? 'active' : '' " @click.prevent="setCabinet('chestnut')" href="#">
          <img src="/static/img/cabinet-thumb-english-chestnut.jpg" alt=""><span>English Chestnut</span>
        </a>
        
         <a v-bind:class="alderwood ? 'active' : '' " @click.prevent="setCabinet('alderwood')" href="#">
          <img src="/static/img/cabinet-thumb-mocha.jpg" alt=""><span>Mocha</span>
        </a>
 -->
        <div v-if="shouldShowBonus" ><figcaption>Additional bathroom option:</figcaption>
          <a v-bind:class="bonus ? 'active' : '' " @click.prevent="toggleBonus" href="#">
          <img v-bind:src="bonusThumb" alt="">
          <span>White Chocolate</span>
        </a> 
        </div>
      </div>
      <div class="popover_footer"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      // selected: null
    }
  },
  props: ['selected', 'settings', 'bonusFeatures', 'room', 'bonus'],
  computed: {
    alderwood () { return this.selected === 'alderwood' },
    chestnut () { return this.selected === 'chestnut' },
    cordovan () { return this.selected === 'cordovan' },
    bonusThumb () {
      
      return this.bonusFeatures[0].features[0].thumb
    },
    shouldShowBonus () {
      return this.bonusFeatures.map( item => item.room ).includes( this.room ) 
    }
  },
  methods: {
     setCabinet (value) {
      //this.selected = value
      this.$dispatch( 'cabinet-changed', value )
    },
    toggleBonus () {
      this.$dispatch( 'cabinetbonus-changed' )
    }
     
  },
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




/** WEBPACK FOOTER **
 ** CabinetControl.vue?b95814de
 **/